export default __webpack_public_path__ + "static/clear-headings-dont-40803a6841d210a580df33fd71f8dc06f4422dc038b3fb7597bc1e7da241a6db.png";